import { useMutation } from "@tanstack/react-query";
import { updateGoogleBusinessProfileOpeningHours } from "../../api/bReviewsApi";

export const useUpdateGoogleBusinessProfileOpeningHours = () => {
  return useMutation({
    mutationFn: ({ locationId, data }) =>
      updateGoogleBusinessProfileOpeningHours(locationId, data),
  });
};
